import React from 'react';

import { useGlobalStore } from '@client/store/globalStore/context/globalContext';
import Backdrop from '@mui/material/Backdrop';
import CircularProgress from '@mui/material/CircularProgress';
import Typography from '@mui/material/Typography';

// exported for testing — window.location is non-configurable in vmThreads
export const _nav = { reload: () => window.location.assign('') };

interface BlockingOverlayProps {
    text: string | null;
}

const BlockingOverlay = ({ text }: BlockingOverlayProps) => {
    const {
        globalState: { socket }
    } = useGlobalStore();

    React.useEffect(() => {
        if (text === null || !socket) {
            return;
        }

        const onConnect = () => _nav.reload();
        socket.on('connect', onConnect);

        return () => {
            socket.off('connect', onConnect);
        };
    }, [text, socket]);

    return (
        <Backdrop open={text !== null} style={{ zIndex: 9999, flexDirection: 'column', gap: '16px', color: '#fff' }}>
            <CircularProgress color="inherit" size={48} />
            <Typography variant="h6" color="inherit" style={{ whiteSpace: 'pre-line', textAlign: 'center' }}>
                {text}
            </Typography>
        </Backdrop>
    );
};

export default BlockingOverlay;
